module.exports = __webpack_public_path__ + "img/miserables_2_lm.b4612c5a.jpg";